import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageIntro from "@/components/feature/PageIntro";
import ContactForm from "./components/ContactForm";
import { Link } from "react-router-dom";
export default function ContactPage() {
  return (
    <>
      <Navbar />
      <main id="main-content">
        <PageIntro
          eyebrow="Contact Harambee"
          title="Every connection starts with a conversation."
        >
          <p>
            Tell us what you’re working toward. We welcome learners,
            entrepreneurs, families, and organizations on the continent and
            across the diaspora.
          </p>
          <a className="text-link" href="mailto:info@harambeeglobal.com">
            info@harambeeglobal.com ↗
          </a>
        </PageIntro>
        <div className="shell work-jump">
          <Link className="text-link" to="/trading-academy#apply">
            Academy interest ↗
          </Link>
          <Link className="text-link" to="/advisory#consult">
            Advisory inquiry ↗
          </Link>
          <Link className="text-link" to="/partnerships#partner-form">
            Partnership inquiry ↗
          </Link>
        </div>
        <ContactForm />
        <section id="your-information" className="section-space bg-[#F8F6F3]">
          <div className="shell purpose-grid">
            <div>
              <p className="eyebrow">Your information</p>
              <h2>
                Share what helps
                <br />
                start the conversation.
              </h2>
            </div>
            <div>
              <p className="body-copy">
                Your form submission is sent to Harambee’s team so we can review
                and respond to your inquiry. Contact details and your message
                are stored in our inquiry system, and staff may receive an email
                notification.
              </p>
              <p className="body-copy">
                Please leave out passwords, identity documents, account numbers,
                and confidential financial information. For questions about
                information you have submitted, contact{" "}
                <a className="text-link" href="mailto:info@harambeeglobal.com">
                  info@harambeeglobal.com
                </a>
                .
              </p>
              <p className="body-copy">
                A general inquiry does not subscribe you to the newsletter. You
                can choose to subscribe separately below.
              </p>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
